<template>
  <div>
    <div class="landscape">
      <div class="chillroom">
        <transition name="fade">
          <div class="chillroom-glow glowing-mobile" v-show="isMobile"></div>
        </transition>

        <transition name="fade">
          <div class="tocorridor" v-show="tocorridor"></div>
        </transition>
        <transition name="fade">
          <div class="on-windows" v-show="onWindows"></div>
        </transition>
        <transition name="fade">
          <div class="on-stories" v-show="onStories"></div>
        </transition>
        <transition name="fade">
          <div class="on-videoScreens" v-show="onVideoScreens"></div>
        </transition>
        <transition name="fade">
          <div class="on-gameTable" v-show="onGameTable"></div>
        </transition>

        <router-link to="/corridor-chill">
          <div
            class="corridor"
            :class="{ cursorRight: tocorridor }"
            @mouseover="
              tocorridor = true;
              $store.commit('setToPlace', 'back_to_corridor');
            "
            @mouseleave="
              tocorridor = false;
              $store.commit('setToPlace', '...');
            "
          ></div>
        </router-link>

        <!-- WINDOWS -->
        <div
          class="windows"
          @mouseover="
            onWindows = true;
            $store.commit('setToPlace', 'observe_space');
          "
          @mouseleave="
            onWindows = false;
            $store.commit('setToPlace', '...');
          "
          @click="observeSpace"
        ></div>
        <div class="observing" v-if="observingSpace">
          <div class="no-scrollbar">
            <h2>Space wandering..</h2>
            <span class="close" @click="observeSpace">X</span>
            <p>
              {{ observedSpace.infos }}
            </p>
            <nav class="nav">
              <a class="link" @click="observeSpace">STEP BACK</a>
            </nav>
          </div>
        </div>
        <img
          class="space-img"
          :src="observedSpace.image"
          v-if="observingSpace"
        />

        <!-- STORIES -->
        <div
          class="stories-past"
          @mouseover="
            onStories = true;
            $store.commit('setToPlace', 'learn_stuff');
          "
          @mouseleave="
            onStories = false;
            $store.commit('setToPlace', '...');
          "
          @click="checkStoriesPast"
        ></div>
        <div class="checking-stories no-scrollbar" v-if="checkingStories">
          <div>
            <h2>from_the_past... <br />{{ nasaInfo.date }}</h2>
            <span class="close" @click="checkStoriesPast">X</span>
            <p>
              {{ nasaInfo.explanation }}
            </p>
            <nav class="nav">
              <a class="link" @click="checkStoriesPast">STEP BACK</a>
            </nav>
          </div>
        </div>
        <img class="story-img" :src="nasaInfo.url" v-if="checkingStories" />

        <!-- VIDEO SCREENS -->
        <div
          class="video-screens"
          @mouseover="
            onVideoScreens = true;
            $store.commit('setToPlace', 'check_videos');
          "
          @mouseleave="
            onVideoScreens = false;
            $store.commit('setToPlace', '...');
          "
          @click="
            checkingVideos = true;
            $store.commit('focusOnStuff');
          "
        ></div>

        <div class="checking-videos no-scrollbar" v-if="checkingVideos">
          <div class="back" @click="backVideos">
            <img src="@/assets/medias/images/backarrow.png" alt="" />
          </div>
          <div class="video-box no-scrollbar" v-if="videoBox == 0">
            <h2>Interesting shit</h2>
            <div @click="addStuff('interesting')">
              <a class="link button">ADD STUFF</a>
            </div>
            <div
              v-for="interesting in interesting_reversed"
              :key="interesting.id"
            >
              <h3>{{ interesting.title }}</h3>
              <iframe
                v-if="interesting.url.indexOf('youtube') > -1"
                :src="interesting.url"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <div v-else>
                <a class="link_stuff" :href="interesting.url" target="_blank"
                  >Link to {{ interesting.title }}</a
                >
              </div>
              <p v-html="interesting.text"></p>
              <hr />
            </div>
          </div>
          <div class="video-box no-scrollbar" v-if="videoBox == 1">
            <h2>Sweet sounding shit</h2>
            <div @click="addStuff('sweet sounding')">
              <a class="link button">ADD STUFF</a>
            </div>
            <h3>Spacevibes - Playlist</h3>
            <iframe
              src="https://www.youtube.com/embed/playlist?list=PLt4cOVR0FgmKQroRKw_aWh593M-iZQtVg&jct=e7GQt0-v1oKQXqImilpzMFbyl5UKjg"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <p>
              Go here if you want to contribute bromingo: www.shorturl.at/ghyIP
            </p>
            <hr />
            <div v-for="sweet in sweet_reversed" :key="sweet.id">
              <h3>{{ sweet.title }}</h3>
              <iframe
                v-if="sweet.url.indexOf('youtube') > -1"
                :src="sweet.url"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <div v-else>
                <a class="link_stuff" :href="sweet.url" target="_blank"
                  >Link to {{ sweet.title }}</a
                >
              </div>
              <p v-html="sweet.text"></p>
              <hr />
            </div>
          </div>
          <div class="video-box no-scrollbar" v-if="videoBox == 2">
            <h2>Dumb shit</h2>
            <div @click="addStuff('dumb')">
              <a class="link button">ADD STUFF</a>
            </div>
            <div v-for="dumb in dumb_reversed" :key="dumb.id">
              <h3>{{ dumb.title }}</h3>
              <iframe
                v-if="dumb.url.indexOf('youtube') > -1"
                :src="dumb.url"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <div v-else>
                <a class="link_stuff" :href="dumb.url" target="_blank"
                  >Link to {{ dumb.title }}</a
                >
              </div>
              <p>{{ dumb.text }}</p>
              <hr />
            </div>
          </div>
          <div class="video-box no-scrollbar" v-if="videoBox == -1">
            <h2>Add stuff to {{ addingTo }} shit</h2>
            <p>
              Do what you want but it'd be easier if you think of a title and a
              short text to describe the {{ addingTo }} content you want to
              share with other fellow humans. (only youtube will be embedded).
              <br />
            </p>
            <p>
              If you have the choice :
            </p>

            <ul>
              <li>
                soundcloud tracks use less resource than youtube video
              </li>
              <li>
                ..
              </li>
            </ul>

            <p style="color: red;">
              {{ errorText }}
            </p>
            <label for="title">Title</label>
            <input type="text" name="title" id="" v-model="addTitle" />
            <label for="text">Text</label>
            <textarea max="250" v-model="addText"></textarea>
            <label for="url">URL</label>
            <input type="text" v-model="addUrl" />
            <div
              class="link button"
              style="width: max-content; margin: auto;"
              @click="addToFirebase()"
            >
              ADD
            </div>
          </div>
          <div class="forward" @click="forwardVideos">
            <img src="@/assets/medias/images/fast-forward.png" alt="" />
          </div>
          <nav class="nav">
            <a
              class="link"
              @click="
                checkingVideos = false;
                $store.commit('focusOnStuff');
              "
              >STEP BACK</a
            >
          </nav>
        </div>

        <!-- GAME TABLE -->
        <div
          class="game-table"
          @mouseover="
            onGameTable = true;
            $store.commit('setToPlace', 'play');
          "
          @mouseleave="
            onGameTable = false;
            $store.commit('setToPlace', '...');
          "
          @click="
            playing = true;
            $store.commit('focusOnStuff');
          "
        ></div>
        <div class="checking-games" v-if="playing">
          <div class="content no-scrollbar">
            <span class="close" @click="playing = false">X</span>

            <h2>Games bruh</h2>
            <p>
              Take a chill pill (while we develop our own games)
            </p>
            <div class="game-content">
              <div class="game-list">
                <ul>
                  <li @click="displayGame = 'chess'">Chess puzzle</li>
                  <li @click="displayGame = 'relax'">La chill pill</li>
                </ul>
              </div>
              <div class="game">
                <iframe
                  v-if="displayGame == 'chess'"
                  src="https://www.chess.com/daily_puzzle"
                ></iframe>
                <iframe
                  v-if="displayGame == 'relax'"
                  src="https://www.addictinggames.com/embed/html5-games/23807"
                  scrolling="no"
                ></iframe>
              </div>
            </div>
          </div>
          <nav class="nav">
            <a
              class="link"
              @click="
                playing = false;
                $store.commit('focusOnStuff');
              "
              >STEP BACK</a
            >
          </nav>
        </div>

        <Portal></Portal>
      </div>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import Portal from "./Portal";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented";
import observing from "@/components/utilities/observing-space.js";
import { db } from "@/plugins/firebase";
const axios = require("axios").default;
export default {
  name: "Chillroom",
  title: "Chillroom",
  components: {
    Portal,
    NotOriented,
  },
  mixins: [MainMixin],
  mounted() {
    this.init();
    let newMsg = {
      text:
        "Take a step back and relax sisters and brothers, you entered the chillroom. Let yourselves be damned by the procrastinating spell, flip your record to the other side and close your eyes. ",
      delay: 7000,
    };

    window.addEventListener("keyup", (e) => this.eventClose(e));
    this.$store.commit("setWanerMsg", newMsg);
  },
  destroyed() {
    window.removeEventListener("keyup", (e) => this.eventClose(e));
  },
  data() {
    return {
      tocorridor: false,
      observingSpace: false,
      nasaInfo: null,
      onWindows: false,
      observing: observing,
      observedSpace: null,
      onStories: false,
      checkingStories: false,
      onVideoScreens: false,
      checkingVideos: false,
      videoBox: 0,
      playing: false,
      onGameTable: false,
      displayGame: null,

      dumb_shit: [],
      interesting_shit: [],
      sweet_sounding_shit: [],
      addingTo: "",
      addTitle: null,
      addText: null,
      addUrl: null,
      errorText: "",
    };
  },
  computed: {
    interesting_reversed() {
      let arr = false;
      if (this.interesting_shit.length > 0) {
        arr = this.interesting_shit;
        arr = arr.reverse();
      }
      return arr;
    },
    dumb_reversed() {
      let arr = false;
      if (this.dumb_shit.length > 0) {
        arr = this.dumb_shit;
        arr = arr.reverse();
      }
      return arr;
    },
    sweet_reversed() {
      let arr = false;
      if (this.sweet_sounding_shit.length > 0) {
        arr = this.sweet_sounding_shit;
        arr = arr.reverse();
      }
      return arr;
    },
  },
  firebase: {
    interesting_shit: db.ref("interesting_shit"),
    dumb_shit: db.ref("dumb_shit"),
    sweet_sounding_shit: db.ref("sweet_sounding_shit"),
  },
  methods: {
    observeSpace() {
      if (this.observingSpace == false) {
        let rand = Math.floor(Math.random() * observing.length);
        this.observedSpace = observing[rand];
        this.observingSpace = true;
        this.$store.commit("focusOnStuff");
      } else {
        this.observingSpace = false;
        this.$store.commit("focusOnStuff");
      }
    },
    addStuff(shit) {
      this.videoBox = -1;
      this.addingTo = shit;
    },
    resetVideoBox(tempBox) {
      (this.addUrl = null), (this.addText = null), (this.addTitle = null);
      this.videoBox = tempBox;
    },
    addToFirebase() {
      if (this.validateStuff()) {
        let newEntry = {
          title: this.addTitle,
          text: this.addText,
          url: this.addUrl,
        };
        if (this.addUrl.indexOf("youtube") > -1)
          newEntry.url = this.editUrlForYoutube();

        let tempBox = 0;
        if (this.addingTo == "interesting") {
          db.ref("interesting_shit")
            .push(newEntry)
            .then((res) => {
              console.log(res);
              this.interesting_shit.reverse();
              this.resetVideoBox(tempBox);
            });
        } else if (this.addingTo == "dumb") {
          db.ref("dumb_shit")
            .push(newEntry)
            .then(() => {
              this.dumb_shit.reverse();
              tempBox = 1;
              this.resetVideoBox(tempBox);
            });
        } else if (this.addingTo == "sweet sounding") {
          db.ref("sweet_sounding_shit")
            .push(newEntry)
            .then(() => {
              this.sweet_sounding_shit.reverse();
              tempBox = 2;
              this.resetVideoBox(tempBox);
            });
        }
      } else {
        this.errorText = "Something is missing..";
        setTimeout(() => {
          this.errorText = "";
        }, 2000);
      }
    },
    editUrlForYoutube() {
      let url = this.addUrl.split(".com/watch?v=");
      url = url.join(".com/embed/");
      url = url.split("&");
      url = url[0];
      return url;
    },
    validateStuff() {
      if (
        this.addTitle !== null &&
        this.addText !== null &&
        this.addUrl !== null
      ) {
        return true;
      }
    },
    checkStoriesPast() {
      if (this.checkingStories == false) {
        axios
          .get(
            "https://api.nasa.gov/planetary/apod?api_key=T2xzH8xXiKjalcDX8tS2WphTMwTrkLo1Ko8OSlr2"
          )
          .then((res) => {
            console.log(res);
            this.nasaInfo = res.data;
            this.checkingStories = true;
            this.$store.commit("focusOnStuff");
          });
      } else {
        this.$store.commit("focusOnStuff");
        this.checkingStories = false;
      }
    },
    forwardVideos() {
      if (this.videoBox < 2) {
        this.videoBox++;
      } else {
        this.videoBox = 0;
      }
    },
    backVideos() {
      if (this.videoBox > 0) {
        this.videoBox--;
      } else {
        this.videoBox = 2;
      }
    },
    eventClose(e) {
      if (e.key === "Escape") {
        if (
          this.checkingVideos ||
          this.checkingStories ||
          this.observingSpace ||
          this.playing
        ) {
          this.$store.commit("focusOnStuff");
          if (this.checkingStories) this.checkingStories = false;
          if (this.checkingVideos) this.checkingVideos = false;
          if (this.playing) this.playing = false;
          if (this.observingSpace) this.observingSpace = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chillroom {
  position: absolute;
  z-index: 0;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chillroom.jpg");
  background-size: 100vw 100vh;
}

.chillroom-glow {
  position: absolute;
  z-index: 0;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chillroom-glow.jpg");
  background-size: 100vw 100vh;
}

.link_stuff {
  color: $blue;
  background-color: $grey;
  padding: 5px;
  border-radius: 3px;

  &:hover {
    background-color: $light-grey;
  }
}

.corridor {
  position: absolute;
  top: 14vh;
  height: 75vh;
  width: 25vw;
  right: 2vw;
}

.tocorridor {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chilltocorridor.jpg");
  background-size: 100vw 100vh;
}

// WINDOWS

.windows {
  position: absolute;
  top: 14vh;
  height: 30vh;
  width: 41vw;
  left: 13vw;
}

.on-windows {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chillroom-windows.jpg");
  background-size: 100vw 100vh;
}

.button {
  border-radius: 5px;
  border: $grey 1px solid;
  padding: 5px;

  &:hover {
    background-color: $light-grey;
    color: $blue;
  }
}

.observing {
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/onWindowChillroom.png");
  background-size: 100vw 100vh;
}

.observing div {
  position: absolute;
  z-index: 4;
  right: 2vw;
  width: 23vw;
  height: 70vh;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 15px;
  overflow-y: scroll;
  text-align: justify;
  padding: 5px;
}

.space-img {
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  height: 100vh;
}

.close {
  position: relative;
  z-index: 4;
  top: -10%;
  right: 5%;
  float: right;
  color: red;
}

// STORIES

.stories-past {
  position: absolute;
  top: 8vh;
  height: 20vh;
  width: 11vw;
  left: 0;
}

.on-stories {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chillroom-spaceStories.jpg");
  background-size: 100vw 100vh;
}

.checking-stories {
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chillroom-screen.png");
  background-size: 100vw 100vh;
}

.story-img {
  position: absolute;
  z-index: 1;
  top: 15vh;
  left: 0px;
  width: 55vw;
  height: 80vh;
}

.checking-stories div {
  position: absolute;
  z-index: 4;
  right: 2vw;
  top: 15vh;
  width: 30vw;
  height: 50vh;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 15px;
  overflow-y: scroll;
  text-align: justify;
  padding: 5px;
}

// VIDEOSCREENS

input,
label {
  display: block;
  margin: auto;
  border-radius: 5px;
}

input,
textarea {
  min-height: 5vh;
  min-width: 15vw;
  margin-bottom: 20px;
  background-color: rgba(250, 250, 250, 0.6);
}

textarea {
  height: 15vh;
}

.video-screens {
  position: absolute;
  top: 12vh;
  height: 20vh;
  width: 11vw;
  right: 28vw;
}

.on-videoScreens {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chillroom-videoScreens.jpg");
  background-size: 100vw 100vh;
}

.checking-videos {
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  display: flex;

  nav {
    position: absolute;
    bottom: 2vh;
    left: 45%;
  }
}

.forward,
.forward img,
.back,
.back img {
  height: 20vh;
  flex: 1;
  margin: auto;
  opacity: 0.6;
  transition: all 0.4s;

  &:hover {
    opacity: 1;
  }
}

.back,
.forward {
  max-width: 10vw;
}

.back {
  margin-right: 2vw;
}

.forward {
  margin-left: 2vw;
}

.video-box {
  position: relative;
  text-align: center;
  max-width: 60vw;
  flex: 2;
  height: 80vh;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  margin: auto;
  overflow-y: scroll;

  iframe {
    height: 45vh;
    width: 80%;
  }
  hr {
    width: 66%;
  }
}

// GAME TABLE

.game-table {
  position: absolute;
  bottom: 9vh;
  height: 30vh;
  width: 28vw;
  left: 28vw;
}

.on-gameTable {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/chillroom-gametable.jpg");
  background-size: 100vw 100vh;
}

.portal {
  position: absolute;
  bottom: 20px;
  left: 25px;
}

.checking-games {
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;

  nav {
    position: absolute;
    bottom: 5vh;
    left: 45%;
  }

  .content {
    margin: 12vh;
    margin-bottom: 0;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.5);
    height: 75vh;
    border-radius: 15px;
    overflow: scroll;
  }

  .game-content {
    display: flex;
    height: 80%;
  }
  .game {
    flex: 3;
    iframe {
      width: 80%;
      height: 80%;
    }
  }
  .game-list {
    flex: 1;
    ul {
      list-style: none;
      padding: 0;
    }
  }
}
</style>
